import { Node } from 'tiptap'

export default class BookmarkEmbed extends Node {
  get name() {
    return 'bookmarkEmbed'
  }

  get schema() {
    return {
      attrs: {
        title: {
          default: '',
        },
        href: {
          default: '',
        },
        src: {
          default: '',
        },
        dataContent: {
          default: '',
        },
      },
      draggable: true,
      selectable: true,
      group: 'block',
      parseDOM: [
        {
          tag: 'div.motyro-bookmark',
          getAttrs(dom) {
            return {
              title: dom.getAttribute('title'),
              href: dom.getAttribute('href'),
              src: dom.getAttribute('src'),
              dataContent: dom.getAttribute('data-content'),
            }
          },
        },
      ],
      toDOM: (node) => [
        'div',
        {
          class: 'motyro-bookmark',
          title: node.attrs.title,
          href: node.attrs.href,
          src: node.attrs.src,
          'data-content': node.attrs.dataContent,
        },
        [
          'div',
          {
            class: 'motyro-bookmark__Content',
          },
          [
            'div',
            {
              class: 'motyro-bookmark__Text',
            },
            ['p', { class: 'motyro-bookmark__Heading' }, node.attrs.title],
            ['p', { class: 'motyro-bookmark__Desc' }, node.attrs.dataContent],
            [
              'a',
              {
                class: 'motyro-bookmark__Link',
                href: node.attrs.href,
                target: '_blank',
              },
              node.attrs.href,
            ],
          ],
          [
            'div',
            {
              class: 'motyro-bookmark__Img',
            },
            [
              'img',
              {
                src: node.attrs.src,
              },
            ],
          ],
        ],
      ],
    }
  }

  get view() {
    return {
      props: ['node', 'view'],
      computed: {
        title() {
          return this.node.attrs.title
        },
        src() {
          return this.node.attrs.src
        },
        href() {
          return this.node.attrs.href
        },
        dataContent() {
          return this.node.attrs.dataContent
        },
      },
      template: `
        <div class="motyro-bookmark" :href="href" target="_blank">
          <div class="motyro-bookmark__Content">
            <div class="motyro-bookmark__Text">
              <p :title="title">{{ title }}</p><p>{{ dataContent }}</p><a :href="href">{{ href }}</a>
            </div>
            <div class="motyro-bookmark__Img">
              <img :src="src" :alt="title" />
            </div>
          </div>
        </div>
      `,
    }
  }

  commands({ type }) {
    return (attrs) => (state, dispatch) => {
      const { selection } = state
      const position = selection.$cursor ? selection.$cursor.pos : selection.$to.pos
      const node = type.create(attrs)
      const transaction = state.tr.insert(position, node)
      dispatch(transaction)
    }
  }
}
